import React, { Component } from 'react';
import T from 'prop-types';
// utils
import { toastResponseErrors } from '../../../utils/response';
import Color from 'color';
// styles
import style from './PersonalColor.mod.css';

const colors = {
  '#1DB0E7': 'Picton Blue',
  '#EE67D7': 'Lavender Magenta',
  '#33C370': 'Shamrock',
  '#FDA93C': 'Yellow Orange',
  '#8A5AFB': 'Heliotrope',
  '#F5CE2E': 'Saffron',
  '#FF5A5A': 'Persimmon',
  '#5BC2C6': 'Fountain Blue'
};

class PersonalColor extends Component {
  selectColor = e => {
    const { updateUser, user } = this.props;
    updateUser({
      id: user.id,
      data: {
        profile_color: e.target.getAttribute('color')
      }
    }).catch(toastResponseErrors);
  };

  render() {
    const { user } = this.props;
    const color = user.profile_color || '#33C370';

    return (
      <div className={style.container}>
        <div
          className={style.border}
          style={{ borderColor: Color(color).fade(0.5) }}
        >
          <div
            className={style.current}
            style={{
              backgroundColor: color,
              color: Color(color).luminosity() > 0.5 ? 'black' : 'white'
            }}
          >
            {colors[color] || 'Pick a color'}
          </div>
        </div>
        <div className={style.label}>Personal Color</div>
        <div className={style.palette}>
          {Object.keys(colors).map((color, index) => (
            <div
              key={index}
              className={style.color}
              color={color}
              onClick={this.selectColor}
              style={{
                backgroundColor: color
              }}
            />
          ))}
        </div>
      </div>
    );
  }
}

PersonalColor.propTypes = {
  user: T.shape({
    id: T.number,
    profile_color: T.string
  }).isRequired,
  updateUser: T.func.isRequired
};

export default PersonalColor;



// WEBPACK FOOTER //
// ./src/containers/UserProfile/components/PersonalColor.jsx